module.exports = __webpack_public_path__ + "img/banner.38e917da.jpg";